// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Changes_topRow__SnVf8{
    display: flex;
}
.Changes_header__kc06U{
    margin-bottom: 15px;
    color: #1F363D;
    font-size: 32px;
    font-family: 'Gotham Bold', serif;
}
@media(max-width: 600px){
    .Changes_header__kc06U{
        font-size: 24px;
    }
}
.Changes_changesContainer__z1Nxq{
    margin-top: 15px;
    margin-left: 5px;
}
@media(max-width: 600px){
    .Changes_changesContainer__z1Nxq{
        margin-top: 15px;
    }
}
.Changes_changes__ImSPo{
    margin-top: 10px;
    padding-left: 25px;
    border-left: 2px solid #ECECEC;
}
.Changes_change__PJ-7w{
    margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/Changes.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB","sourcesContent":[".topRow{\n    display: flex;\n}\n.header{\n    margin-bottom: 15px;\n    color: #1F363D;\n    font-size: 32px;\n    font-family: 'Gotham Bold', serif;\n}\n@media(max-width: 600px){\n    .header{\n        font-size: 24px;\n    }\n}\n.changesContainer{\n    margin-top: 15px;\n    margin-left: 5px;\n}\n@media(max-width: 600px){\n    .changesContainer{\n        margin-top: 15px;\n    }\n}\n.changes{\n    margin-top: 10px;\n    padding-left: 25px;\n    border-left: 2px solid #ECECEC;\n}\n.change{\n    margin-bottom: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topRow": `Changes_topRow__SnVf8`,
	"header": `Changes_header__kc06U`,
	"changesContainer": `Changes_changesContainer__z1Nxq`,
	"changes": `Changes_changes__ImSPo`,
	"change": `Changes_change__PJ-7w`
};
export default ___CSS_LOADER_EXPORT___;
